<div class="container indent-background">
  <div class="flex-container title">
    <span class="col-6">
      Question:
    </span>
    <span class="col-6">
      Answer:
    </span>
  </div>
  <div class="flex-container bottom-gap">
    <span class="col-6">
      My ink has kinda faded….can you do anything about that on the piece I order?
    </span>
    <span class="col-6">
        Yes. We can punch up the vibrancy and sharpen up the clarity in Photoshop.
    </span>
  </div>
  <div class="flex-container bottom-gap">
    <span class="col-6">
      I’m a hairy bastard. Do I still send in my tattoo with hair all over the image?
    </span>
    <span class="col-6">
      You don’t have to shave, you can just grab a scissors and trim the hair way down. Or, shave. But lather up so you don’t cut yourself... you don’t really want an INKfection in real life.
    </span>
  </div>
  <div class="flex-container bottom-gap">
    <span class="col-6">
      I'm a tattoo artist. Do you want to check out my tattoos to maybe feature them as part of the INKfection Collection?
    </span>
    <span class="col-6">
      Absolutely. We love doing cross promotion with tattoo shops.
    </span>
  </div>
  <div class="flex-container bottom-gap">
    <span class="col-6">
      I have a whole sleeve and also a huge back piece... can you do those?
    </span>
    <span class="col-6">
      Yes. Arm and leg sleeves can done as a single elongated, flayed piece or if you want, as individual tattoos in the same frame for a discount over ordering several separate frames. 
      It actually looks pretty cool. I would suggest doing them in odds... 3, 5, 7, etc so it doesn’t look symmetrical when I string them all up. (Serial killers probably aren’t symmetry 
      freaks when stringing up trophies... but that’s just a guess)
      <br>&nbsp;<br>
      For the back piece, the price averages around $250 due to the leather piece required and the bigger frame we custom create to fit the piece perfectly. If you have the means, and 
      want a lifesize skinned flayed body piece, I’ll work with you on price because I really want to tackle that project at some point! Would look crazy in a pro haunt or tattoo shop.
    </span>
  </div>
  <div class="flex-container bottom-gap">
    <span class="col-6">
      My friend has horror tattoos and this would be a perfect gift. Do you do gift cards?
    </span>
    <span class="col-6">
      Yes, we do. Just message us... if your friend is local to Chicagoland, we can create a proper barcoded Ghoulish Mortals gift card for you and give you a INKfection Collection brochure and if you want, a Little Jars of Horror brochure too. They will find something in the store for sure! If not, then they are boring AF and shouldn’t be your friend. If they aren’t local, then we can customize a certificate and send it to you digitally or wrap it up and mail it for a small charge.
    </span>
  </div>
</div>
